import React from "react";
import { Tooltip } from "antd";
import { GrFlagFill } from "react-icons/gr";

// Pure — reproduces getFlagTooltip's render half from grouped flags (FlagsByType).
// `groups` = { flagType: renderable[] } from mappers/flags.groupFlagsByType.
// `gpsChecklist` = the optional GpsFlagChecklist node (modal only; null on the grid).
export const FlagTooltip = ({ groups = {}, uniqueKey = "", isModalText = false, gpsChecklist = null }) => {
    const entries = Object.entries(groups);
    return (
        <>
            {entries.length > 0 && (
                <>
                    <span style={{ fontWeight: "bold" }}> Flags: </span> {gpsChecklist} <br />
                    {entries.map(([flagType, flagNames], i) => (
                        <div key={`Flag${uniqueKey}${flagType}${i}`}>
                            {["Forceplate", "Testing"].includes(flagType)
                                ? flagNames.map(([flagName, flaggedMetrics], j) => (
                                      <span key={`Flag${uniqueKey}${flagType}${flagName}${i}${j}`}>
                                          {isModalText ? (
                                              <>
                                                  {flagName}{" "}
                                                  {flaggedMetrics?.length > 0
                                                      ? `(${flaggedMetrics.join(", ")})`
                                                      : ""}{" "}
                                                  <br />
                                              </>
                                          ) : (
                                              <>
                                                  {flagName} ({flaggedMetrics?.length || 0}) <br />
                                              </>
                                          )}
                                      </span>
                                  ))
                                : flagType === "User Defined"
                                ? flagNames.map(
                                      ([flagName, flaggedDetails], j) =>
                                          flaggedDetails?.length > 0 && (
                                              <div key={`Flag${uniqueKey}${flagType}${flagName}${i}${j}`}>
                                                  {flaggedDetails.map((flag, k) => {
                                                      // A coach flag is tagged by hand and has no
                                                      // operands, so its note takes their place.
                                                      const tooltipContent = flag.notes
                                                          ? <div>{flag.notes}</div>
                                                          : flag.operand_values
                                                          ? Object.entries(flag.operand_values).map(
                                                                ([opKey, opVal]) => (
                                                                    <div key={opKey}>
                                                                        {opKey}: {opVal}
                                                                    </div>
                                                                )
                                                            )
                                                          : null;
                                                      return (
                                                          <span
                                                              key={`Flag${uniqueKey}${flagType}${flag.user_defined_flag_id}${k}`}
                                                              style={{ display: "flex", alignItems: "center", gap: 4 }}
                                                          >
                                                              <GrFlagFill color={flag.color} />
                                                              {isModalText && tooltipContent ? (
                                                                  <Tooltip title={tooltipContent}>
                                                                      <span
                                                                          style={{
                                                                              cursor: "default",
                                                                              borderBottom: "1px dotted currentColor",
                                                                          }}
                                                                      >
                                                                          {flag.name}
                                                                      </span>
                                                                  </Tooltip>
                                                              ) : (
                                                                  flag.name
                                                              )}
                                                          </span>
                                                      );
                                                  })}
                                              </div>
                                          )
                                  )
                                : flagNames.map((flagName, j) => (
                                      <span key={`Flag${uniqueKey}${flagType}${flagName}${i}${j}`}>
                                          {flagName} ({flagType}) <br />
                                      </span>
                                  ))}
                        </div>
                    ))}
                    {isModalText && <br />}
                </>
            )}
            {entries.length === 0 && <>{gpsChecklist}</>}
        </>
    );
};
